import capitalize from 'lodash/capitalize'
import type { IStatusProps } from 'shared/ui/Status'
import { BroadcastStatusConfig } from 'entities/Broadcast'
import { getConfigByStatus as getTriggerStatusConfig } from 'entities/Trigger'
import { getAiCallingStatus } from 'entities/AICalling/ui/AiCallingStatus/config'

const baseStatusConfig: Record<string, IStatusProps> = {
  ...BroadcastStatusConfig,
  active: getTriggerStatusConfig('active'),
  disabled: getTriggerStatusConfig('disabled'),
  unknown: {
    title: 'Unknown',
    emphasis: 'high',
    intent: 'neutral',
  },
}

const isAiCallingType = (type: string) => type.toLowerCase() === 'ai calling agent'

export const getSourceStatusConfig = (type: string, status: string): IStatusProps => {
  const normalized = status?.toLowerCase()

  if (
    isAiCallingType(type) &&
    (normalized === 'active' || normalized === 'disabled' || normalized === 'draft')
  ) {
    const aiConfig = getAiCallingStatus(normalized)
    if (aiConfig) return aiConfig
  }

  return (
    baseStatusConfig[normalized] ?? {
      title: capitalize(status),
      emphasis: 'high',
      intent: 'neutral',
    }
  )
}
